import { render, staticRenderFns } from "./processTransEdit.vue?vue&type=template&id=5ab352b6&scoped=true&"
import script from "./processTransEdit.vue?vue&type=script&lang=js&"
export * from "./processTransEdit.vue?vue&type=script&lang=js&"
import style0 from "./processTransEdit.vue?vue&type=style&index=0&id=5ab352b6&lang=less&scoped=true&"
import style1 from "./processTransEdit.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab352b6",
  null
  
)

component.options.__file = "processTransEdit.vue"
export default component.exports